"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ExerciseService = _interopRequireDefault(require("../services/ExerciseService"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var apiVersion = "v2";
var exerciseService = new _ExerciseService["default"]();
var ewoloConstants = Object.freeze({
  api: {
    authorizationHeader: "authorization",
    apiKeyHeader: "api-key",
    apiKey: "ewolo-general",
    version: apiVersion,
    url: process.env.NODE_ENV === "production" ? "https://ewolo.fitness/api/" + apiVersion : "http://localhost:4000/api/" + apiVersion,
    // TODO: fix mocking of relative urls, https://github.com/wheresrhys/fetch-mock/issues/46
    // url: process.env.NODE_ENV === 'production' ? '/api/' + apiVersion : 'http://192.168.42.10:4000/api/' + apiVersion // TODO: fix mocking of relative urls, https://github.com/wheresrhys/fetch-mock/issues/46
    routes: {
      ROUTE_SIGNUP: "/signup",
      ROUTE_LOGIN: "/login",
      ROUTE_LOG_WORKOUT: "/log-workout",
      ROUTE_EDIT_WORKOUT: "/edit-workout",
      ROUTE_LOG_WEIGHT: "/log-weight",
      ROUTE_AUTHENTICATE: "/authenticate",
      ROUTE_USER_DATA: "/user-data",
      ROUTE_USER_ACCOUNT: "/user-account",
      ROUTE_USERS: "/users",
      ROUTE_ADMIN_USER_DATA: "/admin/user-data",
      ROUTE_PARAM_USER_ID: "/:userId",
      ROUTE_LINKS: "/links",
      ROUTE_LINKS_WORKOUT_DETAILS: "/workout-details",
      ROUTE_PARAM_LINK_ID: "/:linkId",
      ROUTE_WORKOUTS: "/workouts",
      ROUTE_PARAM_WORKOUT_ID: "/:workoutId",
      ROUTE_CREDENTIALS: "/credentials",
      ROUTE_ANALYSIS_WORKOUTS: "/analysis/workouts",
      ROUTE_ANALYSIS_EXERCISE: "/analysis/exercise",
      ROUTE_WEIGHT: "/weight",
      ROUTE_PARAM_WEIGHT_ID: "/:weightId",
      ROUTE_LOG_RUN: "/log-run",
      ROUTE_RUNNING: "/running",
      ROUTE_PARAM_RUNNING_ID: "/:runId"
    }
  },
  storage: {
    authTokenKey: "EWOLO-AUTH-TOKEN",
    userIdKey: "EWOLO-USER-ID",
    authTokenKeyAdmin: "EWOLO-ADMIN-AUTH-TOKEN",
    userIdKeyAdmin: "EWOLO-ADMIN-USER-ID",
    userDataKey: "EWOLO-USER-DATA"
  },
  exerciseNames: Array.from(exerciseService.exercises)
});
var _default = ewoloConstants;
exports["default"] = _default;